import { Controller } from "stimulus"
import _ from 'lodash';

const errorClasses = ['t-border-red-600', 't-border'];

class CompoundInterest extends Controller {
  static targets = [
    'years',
    'amount',
    'rate',
    'resultAmount',
    'resultRate',
    'resultYears',
    'sampleCell',
    'resultArea',
    'table',
    'tableHeaderCell',
    'cell'
  ]

  connect() {
    const mobileDimensions = ['10%', '30%', '30%', '30%']
    const desktopDimensions = ['22%', '26%', '26%', '26%'];
    if (window.matchMedia('(max-width: 768px)').matches) {
      this.dimensions = mobileDimensions;
    } else {
      this.dimensions = desktopDimensions;
    }
  }

  calculate(e) {
    e.preventDefault();
    this.__clearErrors();
    const { years, amount, rate } = this.__verifiedResult();
    if (years.error) {
      this.__addError(this.yearsTarget)
    }
    if (amount.error) {
      this.__addError(this.amountTarget)
    }
    if (rate.error) {
      this.__addError(this.rateTarget)
    }
    if (years.error || amount.error || rate.error) {
      return;
    }

    this.removeCurrentCells();
    this.resultAreaTarget.classList.remove('t-hidden');
    this.resultAmountTarget.textContent = `$${amount.value}`;
    this.resultRateTarget.textContent = `${rate.value * 100}%`;
    this.resultYearsTarget.textContent = years.value;
    const baseCell = this.sampleCellTarget.cloneNode();
    baseCell.classList.remove('t-hidden');
    baseCell.setAttribute('data-compound-interest-target', 'cell');
    let currentAmount = amount.value;
    let currentReturn = 0;
    let totalReturn = 0;

    // Header cells
    this.dimensions.forEach((width, col) => {
      this.tableHeaderCellTargets[col].style.width = width;
    });

    // Body Cells
    [...Array(years.value).keys()].forEach(row => {
      this.dimensions.forEach((width, col) => {
        const cell = baseCell.cloneNode();
        cell.style.width = width;
        if (col == 0) {
          // year
          cell.textContent = row + 1;
        } else if (col == 1) {
          // this year's return
          cell.textContent = `$${(currentAmount * rate.value).toFixed(2)}`;
          currentReturn = currentAmount * rate.value;
          totalReturn += currentReturn;
        } else if (col == 2) {
          // total returns
          cell.textContent = `$${totalReturn.toFixed(2)}`;
        } else if (col == 3) {
          // total money
          currentAmount += currentReturn;
          cell.textContent = `$${currentAmount.toFixed(2)}`;
        }
        this.tableTarget.appendChild(cell);
      })
    })
  }

  removeCurrentCells() {
    if (this.hasCellTarget) {
      this.cellTargets.forEach(e => {
        e.remove();
      })
    }
  }

  __parse(value) {
    const result = +value;
    if (_.isNaN(result)) {
      return null;
    } else {
      return result;
    }
  }

  __verifiedResult() {
    const [years, amount, rate] = [this.yearsTarget.value, this.amountTarget.value, this.rateTarget.value];
    const result = {}
    if (_.isEmpty(years) || _.isNull(this.__parse(years))) {
      result.years = {
        error: true,
        message: 'Invalid years.'
      }
    } else {
      result.years = {
        error: false,
        value: this.__parse(years)
      }
    }
    if (_.isEmpty(amount) || _.isNull(this.__parse(amount))) {
      result.amount = {
        error: true,
        message: 'Invalid base amount.'
      }
    } else {
      result.amount = {
        error: false,
        value: this.__parse(amount)
      }
    }
    if (_.isEmpty(rate) || _.isNull(this.__parse(rate))) {
      result.rate = {
        error: true,
        message: 'Invalid rate.'
      }
    } else {
      result.rate = {
        error: false,
        value: this.__parse(rate) / 100
      }
    }
    return result;
  }

  __clearErrors() {
    this.yearsTarget.parentNode.classList.remove(...errorClasses)
    this.amountTarget.parentNode.classList.remove(...errorClasses)
    this.rateTarget.parentNode.classList.remove(...errorClasses)
  }

  __addError(element) {
    element.parentNode.classList.add(...errorClasses);
  }
}

export default CompoundInterest;
